export const TEACHER_PREFERENCE_STATUS = {
  FREE: 'free',
  PREFER_AWAY: 'prefer_away',
  CANNOT: 'cannot',
}; 